/**
 * DockCapacitySchema — per-dock capacity configuration for Pylon scheduling.
 * Anchors patent F-PYLON-ASRS-AWARENESS-001.
 */
import { z } from 'zod';

export const DockCapacitySchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  dockId: z.string(),
  dockName: z.string(),
  dockType: z.enum(['dry', 'reefer', 'hazmat', 'oversized']),
  maxConcurrentAppointments: z.number().min(1),
  asrsBufferMinutes: z.number().default(30),
  createdAt: z.string(),   // ISO string (not Date — Firestore round-trip)
  updatedAt: z.string(),
});
